import { render, staticRenderFns } from "./ClaimWindow.vue?vue&type=template&id=e2b16a04&"
import script from "./ClaimWindow.vue?vue&type=script&lang=js&"
export * from "./ClaimWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports